import axios from 'axios';
import store from '../store/';
import AuthService from "@/services/AuthService";

export default () => {
  const API = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-language': store.state.user.language,
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  });

  API.interceptors.response.use(
    null,
    (error) => {
      if (error.response.status === 401) {
        /*const originalRequest = error.config;
        const currentAccessToken = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refresh_token');
        // if token expired and the unsuccessful request used the expired token then try to refresh it and make another request with updated token
        if (!AuthService.IsTokenValid(currentAccessToken) && refreshToken && originalRequest.headers['Authorization'].endsWith(currentAccessToken)) {
          return AuthService.RefreshToken(refreshToken)
            .then(newAccessToken => {
              originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
              return API(originalRequest);
            });
        }*/
        // if no tokens stored or token is valid but user has no rights to make this request then redirect to the login page
        window.location.href = window.logoutUrl;
      }
      return Promise.reject(error);
    }
  )

  return API;
}
